module.exports = __webpack_public_path__ + "img/moon.ae516172.png";